<template>
  <div class="signin">
    <div class="title">
      <img src="../assets/title-min.png" alt="title" class="msg" />
      <div class="post left"></div>
      <div class="post right"></div>
    </div>
    <div class="content">
      <div class="box">
        <p class="top">每日签到即可获得抽奖次数，累计天数越多，奖励越丰厚</p>

        <div :class="['progress','day'+status.days]">
          <div class="progress-box"></div>
          <button class="gift" @click.stop="handleSignin" :disabled="status.isSignin === 1">
            <div class="sign" v-if="status.isSignin===0">签到</div>
            <div class="desc">{{status.days ? signinList[status.days-1].name : signinList[0].name}}</div>
          </button>
        </div>
        <div class="days">
          <span>第一天</span>
          <span>第二天</span>
          <span>第三天</span>
          <span>第四天</span>
          <span>第五天</span>
          <span>第六天</span>
          <span>第七天</span>
          <span>第八天</span>
        </div>
        <button class="btn" @click.stop="showGoodsPrize">查看其他奖励></button>
      </div>
      <img src="../assets/leaf-min.png" alt="leaf" class="big-leaf" />
      <img src="../assets/leaf-min.png" alt="leaf" class="small-leaf" />
    </div>
    <Alert :show="kaiguan" @cancle-alert="kaiguan=!kaiguan">
      <template v-slot:title>每日签到奖励</template>
      <template v-slot:content>
        <div class="alert">
          <div class="day-goods mb6">
            <div class="top">第一天</div>
            <p class="num">抽奖次数+3</p>
            <img src="../assets/d1-min.png" alt="d1" />
          </div>
          <div class="day-goods mb6">
            <div class="top">第二天</div>
            <p class="num">抽奖次数+3</p>
            <img src="../assets/d2-min.png" alt="d2" />
          </div>
          <div class="day-goods mb6">
            <div class="top">第三天</div>
            <p class="num">抽奖次数+3</p>
            <img src="../assets/d3-min.png" alt="d3" />
          </div>
          <div class="day-goods mb6">
            <div class="top">第四天</div>
            <p class="num">抽奖次数+3</p>
            <img src="../assets/d4-min.png" alt="d4" />
          </div>
          <div class="day-goods">
            <div class="top">第五天</div>
            <p class="num">抽奖次数+3</p>
            <img src="../assets/d5-min.png" alt="d5" />
          </div>
          <div class="day-goods">
            <div class="top">第六天</div>
            <p class="num">抽奖次数+3</p>
            <img src="../assets/d6-min.png" alt="d6" />
          </div>
          <div class="day-goods">
            <div class="top">第七天</div>
            <p class="num">抽奖次数+3</p>
            <img src="../assets/d7-min.png" alt="d7" />
          </div>
          <div class="day-goods">
            <div class="top">第八天</div>
            <p class="num">抽奖次数+3</p>
            <img src="../assets/d8-min.png" alt="d8" />
          </div>
        </div>
      </template>
    </Alert>
    <ShowGames :show="openShowGames" from="signin" @signin-success="SigninSuccess"/>
  </div>
</template>

<script>
import Alert from "../common/Alert";
import ShowGames from './ShowGames';
export default {
  name: "Signin",
  components: {
    Alert,
    ShowGames
  },
  props: {
    loginStatus: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    kaiguan: false,
    signinList: [
      {
        day: "第一天",
        name: "满30减4元优惠券"
      },
      {
        day: "第二天",
        name: "满60减10元优惠券"
      },
      {
        day: "第三天",
        name: "满98减18元优惠券"
      },
      {
        day: "第四天",
        name: "满128减25元优惠券"
      },
      {
        day: "第五天",
        name: "满198减45元优惠券"
      },
      {
        day: "第六天",
        name: "满328减78元优惠券"
      },
      {
        day: "第七天",
        name: "满488减118元优惠券"
      },
      {
        day: "第八天",
        name: "满648减162元优惠券"
      }
    ],
    status: {
      days: 0,
      isSignin: 0
    },
    openShowGames:false
  }),
  watch: {
    loginStatus: function(val) {
      if (!val) {
        this.status = {
          days: 0,
          isSignin: 0
        };
      } else {
        this.getSigninList();
      }
    }
  },
  created() {
    if (this.isLogin()) {
      this.getSigninList();
    }
  },
  methods: {
    //展示签到奖励列表
    showGoodsPrize() {
      if (!this.isLogin()) {
        this.$toast({
          message: "请登录",
          duration: 1200,
          position: "bottom"
        });
        this.$parent.open("login");
        return;
      }
      this.kaiguan = !this.kaiguan;
    },
    open(type){
      switch(type){
        case 'showGames':
          this.openShowGames=!this.openShowGames;
          break;
        default:break;
      }
    },
    //判断是否签到
    async getSigninList() {
      let { data } = await this.$api.activity.signinList();
      if (data.code === 0) {
        let {days,isSignin}=data.data;
        if(days>=8){
          days=8;
          isSignin=1;
        }
        if(isSignin!==0){
          days--
        }
        this.status ={
          days,
          isSignin
        };
      }
    },
    //判断是否登录
    isLogin() {
      return this.loginStatus ? true : false;
    },
    //签到
    async handleSignin() {
      if (!this.isLogin()) {
        this.$toast({
          message: "请登录",
          duration: 1200,
          position: "bottom"
        });
        this.$parent.open("login");
        return;
      }
      this.open('showGames')
    },
    SigninSuccess(){
      this.open('showGames');
      this.getSigninList()
      this.$parent.handleIsLogin()
    }
  }
};
</script>

<style scoped lang="scss">
.signin {
  padding: 0 40px;
  margin-bottom: 110px;
  .title {
    margin: 0 auto 50px;
    width: 914px;
    height: 70px;
    border-radius: 35px;
    background: linear-gradient(0deg, #dc580d, #e28215);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    box-shadow: -8px 0px 10px 0px #f6832d;
    .msg {
      width: 520px;
    }
    .post {
      position: absolute;
      width: 20px;
      height: 50px;
      background: linear-gradient(
        90deg,
        rgba(241, 195, 151, 1),
        rgba(255, 221, 179, 1)
      );
      box-shadow: -12px 0px 10px 0px #eb6e1a;
      z-index: 0;
    }
    .left {
      bottom: -50px;
      left: 140px;
    }
    .right {
      bottom: -50px;
      right: 140px;
    }
  }
  .content {
    position: relative;
    z-index: 1;
    width: 100%;
    background: #fff;
    border-radius: 30px;
    height: 520px;
    box-sizing: border-box;
    padding: 10px;
    position: relative;
    .box {
      background: rgba(255, 253, 251, 1);
      box-shadow: inset 0px 0px 20px 0px rgba(244, 160, 68, 0.78);
      border-radius: 30px;
      height: 100%;
      padding-top: 40px;
      box-sizing: border-box;
      font-size: 12px;
      text-align: center;
      .top {
        display: inline-block;
        padding:8px 20px;
        font-size: 24px;
        color: #461e01;
        background-image: url("../assets/kuang-min.png");
        background-size: 100% 100%;
        margin: 0 auto 166px;
      }
      .progress {
        width: 900px;
        height: 24px;
        position: relative;
        background-image: url("../assets/progress-min.png");
        background-size: 100% 100%;
        margin: 0 auto 24px;
        position: relative;
        .progress-box {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          border-radius: 12px;
          background: url("../assets/color-min.png") repeat-x;
          background-size: 100% 100%;
        }
        .gift {
          cursor: pointer;
          position: absolute;
          bottom: -20px;
          left: 22px;
          width: 90px;
          height: 80px;
          background-image: url("../assets/gift-min.png");
          background-size: 100%;
          .sign {
            position: absolute;
            z-index: 11;
            left: 50px;
            top: -12px;
            height: 30px;
            line-height: 30px;
            min-width: 70px;
            font-size: 20px;
            text-align: center;
            color: #ffe7cf;
            background: linear-gradient(
              90deg,
              rgba(255, 99, 96, 1),
              rgba(255, 129, 91, 1)
            );
            border: 1px solid rgba(255, 245, 225, 1);
            border-radius: 10px 10px 10px 0px;
          }
          .desc {
            position: absolute;
            top: -90px;
            left: 50%;
            transform: translateX(-50%);
            min-width: 280px;
            padding: 0 10px;
            height: 60px;
            border-radius: 30px;
            line-height: 60px;
            font-size: 28px;
            color: #fff;
            text-align: center;
            background: #d15b16;
            &::after {
              display: block;
              content: "";
              border-width: 12px 12px 12px 12px;
              border-style: solid;
              border-color: #d15b16 transparent transparent transparent;
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              top: 100%;
            }
          }
        }
      }
      .day0 {
        .progress-box {
          width: 80px;
        }
        .gift {
          left: 22px;
        }
      }
      // .day1 {
      //   .progress-box {
      //     width: 80px;
      //   }
      //   .gift {
      //     left: 22px;
      //   }
      // }
      .day1 {
        .progress-box {
          width: 200px;
        }
        .gift {
          left: 130px;
        }
      }
      .day2 {
        .progress-box {
          width: 300px;
        }
        .gift {
          left: 240px;
        }
      }
      .day3 {
        .progress-box {
          width: 400px;
        }
        .gift {
          left: 350px;
        }
      }
      .day4 {
        .progress-box {
          width: 500px;
        }
        .gift {
          left: 455px;
        }
      }
      .day5 {
        .progress-box {
          width: 600px;
        }
        .gift {
          left: 560px;
        }
      }
      .day6 {
        .progress-box {
          width: 700px;
        }
        .gift {
          left: 680px;
        }
      }
      .day7 {
        .progress-box {
          width: 830px;
        }
        .gift {
          left: 790px;
        }
      }
      .days {
        font-size: 20px;
        color: #6e3521;
        padding: 0 50px;
        display: flex;
        justify-content: space-around;
        margin-bottom: 65px;
      }
      .btn {
        cursor: pointer;
        display: block;
        margin: 0 auto;
        width: 300px;
        height: 60px;
        background: rgba(248, 72, 72, 1);
        font-size: 24px;
        color: #fff;
        border-radius: 30px;
        line-height: 60px;
        text-align: center;
      }
    }
    .small-leaf {
      position: absolute;
      width: 83px;
      bottom: -60px;
      left: 15px;
    }
    .big-leaf {
      position: absolute;
      width: 127px;
      top: -20px;
      right: -15px;
    }
  }
}
.alert {
  box-sizing: border-box;
  width: 100%;
  width: 950px;
  box-sizing: border-box;
  padding: 65px 50px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .day-goods {
    width: 180px;
    height: 260px;
    background: rgba(255, 255, 255, 1);
    border: 2px solid rgba(255, 218, 188, 1);
    box-shadow: 5px 9px 10px 0px rgba(231, 150, 93, 0.19);
    border-radius: 10px;
    img {
      display: block;
      margin: 0 auto;
      width: 106px;
    }
    .top {
      width: 113px;
      height: 34px;
      background: rgba(255, 160, 81, 1);
      border-radius: 0 0 10px 10px;
      margin: 0 auto;
      font-size: 20px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .num {
      font-size: 24px;
      color: #ec370c;
      text-align: center;
      height: 80px;
      line-height: 80px;
    }
  }
  .mb6 {
    margin-bottom: 60px;
  }
}
</style>